export class Usuario {
    usuLogin: string;
    codigoSucursal: string;
    sucursal: string;
    idSucu: number;
    idUsua: number;
    nombre: string;
    email: string;
    idVend: number;

    codigoVendedor: string;

    diasCaducidad: string;
    estado: string;
    nombreRol: string;
    usuActivo: string;
    usuApellidos: string;
    usuCodigo: string;
    usuCodigoInterno: string;
    usuCorreo: string;
    usuIntentosFallidos: string;
    usuNombres: string;
    usuUltmimaModificacionPass: string;
    sucCodigoInterno: string;
    usuContrasena: string;

    esCliente: boolean;
    mensajeCliente: string;
    linkClientePago: string;
    tipoAutorizador:number;

    constructor(){}
}
